"use client";
import "./globals.css";
import "aos/dist/aos.css";
import { StoreProvider } from "../StoreContext";
import { Inter } from "next/font/google";
import { GoogleTagManager } from "@next/third-parties/google";
import "react-toastify/dist/ReactToastify.css";
import TawkTo from "./componenets/Tawko";

import PerformanceMonitor from "./componenets/PerformanceMonitor";
const inter = Inter({
  subsets: ["latin"],
  display: "swap", // important to avoid layout shift
  weight: ["400", "700"],
});

export default function RootLayout({ children }) {

  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};

  // GTM-WFQND23D for newqasir
  // GTM-KSPR6W8B for prod
  return (
    <html lang="en">

    <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />
      <GoogleTagManager gtmId="GTM-WFQND23D" />
      
      <body className={inter.className}>
        <StoreProvider>
          <TawkTo />
          <PerformanceMonitor />
          {children}
        </StoreProvider>
      </body>
    </html>
  );
}